var categoryListStatic = {
};

function categoryList() {
		categoryListStatic = this;
}

categoryList.prototype = {

	back: function() {
		var chs = player.currentHistoryState;
		
		
		$(chs.current).hide();
		
		$(chs.parent).show();
				
		/*
		$("#panosback a").last().parent().remove();
		
		$("#panosback .breadcrumb").last().children(".bcend").css("display", "none");
		*/
		
		//$(chs.current).css("opacity","0");		
		//$(chs.parent).css("opacity","1");
		
		/*
		$(chs.current).css("transform","translate3d(" + player._width + "px,0px,0px)");
		$(chs.current).css("-webkit-transform","translate3d(" + player._width + "px,0px,0px)");
		$(chs.current).css("-moz-transform","translate3d(" + player._width + "px,0px,0px)");
		
		$(chs.parent).css("transform","translate3d(0px,0px,0px)");
		$(chs.parent).css("-webkit-transform","translate3d(0px,0px,0px)");
		$(chs.parent).css("-moz-transform","translate3d(0px,0px,0px)");
		*/
	},
	
	multiBack: function(event) {
		history.back();
		
		event.preventDefault();
		/*
		var cp = $(this).attr("data-count");
		var max = $("#panosback a").length;
		
		if (cp == undefined) cp = 0;
		
		if (max == 1) history.back();
		
		for(var i = 0; i < max - cp; i ++) {
			history.back();
		}
		*/
	},

	openMenu: function(pdiv) {
	},
	
	openPlace: function(id) {
	
		//document.title = "scrolling";
	
		if (this.scroll.isScrolling()) {
			return;
		}
		
		document.location = "\index.php?id=" + id;
	},
	
	loadFolder: function(n) {
	
		if (this.scroll.isScrolling()) {
			return;
		}
	
		if (!player.folders[n].opened) {
			$("#folder_" + n).show();
		} else $("#folder_" + n).hide();
		
		player.folders[n].opened = !player.folders[n].opened;
		
		if (player.folders[n].loaded) return;
		
		for(var i = 0; i < player.folders[n].panos.length; i ++) {
			data = player.folders[n].panos;
			elem = $("<div class='panolink' id='pano" + data[i].id + "'><a ontouchend = 'categoryListStatic.openPlace(" + data[i].id + ")'><img src='" + data[i].thumb + "' width='200' height='100'><div class='bg'><span>" + data[i].pano_title + "</span></div></a></div>");
			$("#folder_" + n).append(elem);
		}
		player.folders[n].loaded = true;
		this.scroll.calculateBounds();
	},
	
	getCurrent: function(data) {
		return this.current;
	},
	
	loadPanoList: function(data) {
		var currentpano;
		var currentfolder;
		var current = {id:"-1", title:"Lista panoram"};
		current.panos = [];
		
		//player.current = null;
		this.scroll = new Scroller("#panos","#ui");
				
		if (!player.imagesLoaded) {
			
			currentfolder = null;
			
			for(var i = 0; i < data.length; i ++) {
				if (data[i].type == "folder") {
					if (current != null) {
						player.folders.push(current);
					}
					
					if (data.length > i + 1 && data[i + 1].type == "folder") {
						elem = $("<div class='folderempty'>" + data[i].title + "</div>");
					} else {
						// javascript:void(null);
						elem = $("<div class='folder'><a href='javascript:void(null);' name='#f" + player.folders.length + "' ontouchend='player.list.loadFolder(" + player.folders.length + ");'>" + data[i].title  + "</a></div><div id='folder_" + player.folders.length + "'></div>");
					}
					$("#panos").append(elem);
					
					current = {id:data[i].id, title:data[i].title};
					current.panos = [];
				} else {
				
					current.panos.push(data[i]);
					/*
					elem = $("<div class='panolink'><a href='index.php?id=" + data[i].id + "'><imrrg data-src='" + data[i].thumb + "' width='200' height='100'><div class='bg'><span>" + data[i].pano_title + "</span></div></a></div>");
//					elem = $("<div class='panolink'><a href='index.php?id=" + data[i].id + "'><img src='' data-src='" + player.storage + "/thumb.php?id=" + data[i].id + "'><div class='bg'><span>" + data[i].pano_title + "</span></div></a></div>");
					$("#panos").append(elem);
					*/
					if (data[i].id == player.ident) {
						currentpano = data[i];
						currentfolder = player.folders.length;
					}					
				}
			}
			
			player.folders.push(current);
			
			player.imagesLoaded = true;
			
			this.scroll.calculateBounds();
			
			if (currentfolder != null) {				
				player.list.loadFolder(currentfolder);
			//	document.title = -50 * currentfolder;
				this.scroll.jumpTo(0,-57 * (currentfolder - 1));
			}
		}
		
		for(var i = 0; i < player.folders.length; i ++) {
			//player.loadFolder(i);
		}
		
		this.current = currentpano;
	}	
}